module.exports = " <div> <button v-if=\"! isRevealed\" @click=reveal class=btn v-tip :tip-text=config.instructions>{{ config.display }}</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/RevealerFieldtype.vue
// module id = 735
// module chunks = 0